module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("Automações")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n                  Operações em massa sobre GRVs a partir de planilha.\n                ")])])])]), _vm._v(" "), (_vm.automacoes.length) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("O que você quer fazer?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selecionada),
      expression: "selecionada"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "480px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione uma automação...")]), _vm._v(" "), _vm._l((_vm.automacoes), function(automacao) {
    return _c('option', {
      key: automacao.codigo,
      domProps: {
        "value": automacao.codigo
      }
    }, [_vm._v("\n                    " + _vm._s(automacao.label) + "\n                  ")])
  })], 2), _vm._v(" "), (_vm.automacaoAtual) ? _c('p', {
    staticClass: "text-muted m-t-xs"
  }, [_vm._v(_vm._s(_vm.automacaoAtual.descricao))]) : _vm._e()])]), _vm._v(" "), (_vm.automacaoAtual) ? _c('div', {
    staticClass: "b-t"
  }, [_c(_vm.automacaoAtual.component, {
    key: _vm.automacaoAtual.codigo,
    tag: "component",
    on: {
      "close": _vm.limpar,
      "finishSubmit": function () {}
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "panel panel-default wrapper-md text-muted"
  }, [_vm._v("\n            Você não tem permissão para nenhuma automação no momento.\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7175e1a0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/automacoes/components/Automacoes.vue
// module id = 1948
// module chunks = 18